import axios from 'axios'
import {createAppInstance} from '@/api/appInstance'
import {createAPPAxiosInstance} from '@/api/index'
import store, { setGlobalError } from "@/store";
import Message from 'ant-design-vue/lib/message'

import Vue from 'vue'

function getAppConfig(appID, app) {
    Message.loading('loading...',0);
    axios.get(app.$BASE_URL + '/api/app/cfg', {
        headers: {appsign: appID}
    }).then(res => {
        Message.destroy();
        if (res.data.sts == 1) {
            const appConfig = res.data.data;
            Vue.prototype.$APPCFG = appConfig;
            Vue.prototype.$APPID = appConfig.appid;
            Vue.prototype.$GS_CUR = appConfig.cfg_cur;
            Vue.prototype.$GS_RMB = appConfig.cfg_rmb;
            Vue.prototype.$GS_WHT = appConfig.cfg_weight;
            Vue.prototype.$STC_URL = appConfig.stcUrl;
            Vue.prototype.$APP_MANAGE = createAppInstance();
            Vue.prototype.$HTTP = createAPPAxiosInstance(app);
            store.commit('setHTTP', createAPPAxiosInstance(app));
            document.querySelector('title').innerText = res.data.data.cfg_title ? res.data.data.cfg_title : '微商城';
            app.$mount('#app');
        }
    }).catch(error => {
        setGlobalError('APPID 初始化失败！');
    })
}


export function initAPP(app) {
    const appID = 20111204;
    getAppConfig(appID, app);
}
